import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import { logoutUser } from "./auth"; 

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return !!localStorage.getItem("authUser") || !!localStorage.getItem("token");
    });

    const login = (userOrToken) => {
        if (typeof userOrToken === "string") {
            localStorage.setItem("token", userOrToken);
        } else if (userOrToken) {
            localStorage.setItem("authUser", JSON.stringify(userOrToken));
        }
        setIsAuthenticated(true);
    };

    const logout = async () => {
        await logoutUser({ callBackend: true });
        setIsAuthenticated(false);
    };

    const value = useMemo(() => ({ isAuthenticated, login, logout }), [isAuthenticated]);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
    return ctx;
}
